/**
 * Workaround for PrimeNG Drawer overlay mask not being removed after close.
 * https://github.com/primefaces/primeng/issues/19367
 *
 * PrimeNG's disableModality() adds `p-overlay-mask-leave-active` to the mask
 * and listens for `animationend` via Renderer2.listen() to call destroyModal().
 * The listener never fires reliably on dynamically-created mask elements.
 *
 * This patch:
 * 1. Provides the missing @keyframes animation (added in styles.scss).
 * 2. Registers a single capture-phase animationend listener on document.body
 *    that removes the mask when the leave animation completes.
 *
 * Call once at app startup (e.g. main.ts). Safe to remove when PrimeNG ships a fix.
 */
export function patchPrimeNgDrawerMask(): void {
  document.body.addEventListener(
    "animationend",
    (e: AnimationEvent) => {
      if (e.animationName === "p-overlay-mask-leave") {
        (e.target as HTMLElement)?.remove();
      }
    },
    true,
  );
}
